import Cookies from 'js-cookie'

export const setItem = (key, value, expires) => {
	Cookies.set(key, value, {
		expires,
	})
}

export const getItem = key => {
	return Cookies.get(key)
}

export const removeItem = key => {
	Cookies.remove(key)
}

export const removeAll = () => {
	Object.keys(Cookies.get()).forEach(cookieName => {
		Cookies.remove(cookieName)
	})
}

export default {
	setItem,
	getItem,
	removeItem,
	removeAll,
}
